<template>
  <div class="container">
    <!-- 汇总 -->
    <div class="summary">
      <div class="card">
        <div>今日消耗</div>
        <div class="value">{{ totalCost | currency }}</div>
      </div>
      <div class="card green">
        <div>昨日消耗</div>
        <div class="value">{{ totalYesterdayCost | currency }}</div>
      </div>
    </div>

    <!-- 刷新 -->
    <div class="refresh">
      <el-button type="primary" size="mini" icon="el-icon-refresh" @click="fetchData" :loading="loading">
        刷新
      </el-button>
    </div>

    <!-- 表头 -->
    <div class="table header-fixed">
      <div class="row header-row">
        <div>端口名称</div>
        <div @click="changeSort('todayCashCost')">今日 ⬍</div>
        <div @click="changeSort('yesterdayCost')">昨日 ⬍</div>
        <div @click="changeSort('cashBal')">余额 ⬍</div>
      </div>
    </div>

    <!-- 列表 -->
    <div v-if="loading" class="loading">加载中...</div>

    <div v-else>
      <div v-for="group in groupedList" :key="group.recordAccount" class="card-item">

        <!-- 分组 -->
        <div class="header">
          <div class="title">{{ group.recordAccount }}</div>
          <div class="stats">
            今 {{ group.today | currency }} / 昨 {{ group.yesterday | currency }}
          </div>
        </div>

        <!-- 数据 -->
        <div class="table">
          <div class="row" v-for="item in group.items" :key="item.ownerName">
            <div class="name">{{ item.ownerName }}</div>
            <div>{{ item.todayCashCost | currency }}</div>
            <div>{{ item.yesterdayCost | currency }}</div>
            <div :class="{ warn: item.cashBal < 10000 }">
              {{ item.cashBal | currency }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      rawData: [],
      groupedList: [],
      loading: false,
      totalCost: 0,
      totalYesterdayCost: 0,
      sortKey: 'todayCashCost',
      sortOrder: 'desc'
    }
  },

  filters: {
    currency(v) {
      if (!v) return '0.00'
      return (v / 100).toFixed(2)
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      axios.get('https://wcry.zjwec.cn/operation/oppo/project/account/queryMktData', {
        params: { groupName: '陈慧组' }
      }).then(res => {
        const data = res.data.data || []
        this.rawData = data
        this.processData()
        this.calc()
        this.$message.success('刷新成功')
      }).finally(() => {
        this.loading = false
      })
    },

    // 核心处理
    processData() {
      const result = []

      this.rawData.forEach(group => {
        const items = [...group.items]

        // 排序
        items.sort((a, b) => {
          const v1 = a[this.sortKey] || 0
          const v2 = b[this.sortKey] || 0
          return this.sortOrder === 'asc' ? v1 - v2 : v2 - v1
        })

        result.push({
          recordAccount: group.recordAccount,
          items,
          today: group.todayCashCostAll || 0,
          yesterday: items.reduce((a, b) => a + (b.yesterdayCost || 0), 0)
        })
      })

      this.groupedList = result
    },

    changeSort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortOrder = 'desc'
      }
      this.processData()
    },

    calc() {
      let t = 0, y = 0
      this.rawData.forEach(i => {
        t += i.todayCashCostAll || 0
        i.items.forEach(s => y += s.yesterdayCost || 0)
      })
      this.totalCost = t
      this.totalYesterdayCost = y
    }
  }
}
</script>

<style scoped>
.container {
  padding: 10px;
  background: #f5f6f8;
}

/* 汇总 */
.summary {
  display: flex;
  gap: 8px;
}
.card {
  flex: 1;
  padding: 10px;
  border-radius: 8px;
  background: linear-gradient(135deg, #1890ff, #36cfc9);
  color: #fff;
}
.card.green {
  background: linear-gradient(135deg, #52c41a, #95de64);
}
.value {
  font-size: 18px;
  font-weight: bold;
}

/* 刷新 */
.refresh {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
}

/* 表头 */
.header-fixed {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  border-radius: 8px;
  margin-bottom: 8px;
}

/* 卡片 */
.card-item {
  background: #fff;
  margin-bottom: 8px;
  border-radius: 8px;
  padding: 8px;
}

/* 分组头 */
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}
.title {
  font-weight: bold;
}
.stats {
  font-size: 12px;
  color: #666;
}

/* 表格 */
.table {
  font-size: 12px;
}
.row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding: 8px 6px;
  border-bottom: 1px solid #eee;
}
.header-row {
  font-weight: bold;
  background: #fafafa;
}

/* 文本 */
.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 预警 */
.warn {
  color: red;
  font-weight: bold;
}

/* loading */
.loading {
  text-align: center;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/oppo/data/chData.vue